export const translations = {
  pt: {
    appName: "Z Music",
    tagline: "Seu som, do seu jeito",
    library: "Biblioteca",
    settings: "Ajustes",
    home: "Início",
    upload: "Enviar músicas",
    uploadHint: "Arraste seus arquivos ou toque para escolher",
    uploadFormats: "MP3 · WAV · M4A · FLAC",
    processing: "Processando",
    empty: "Sua biblioteca está vazia",
    emptyHint: "Envie suas músicas para começar a ouvir",
    songsCount: (n) => `${n} ${n === 1 ? "música" : "músicas"}`,
    nowPlaying: "Tocando agora",
    download: "Baixar",
    delete: "Excluir",
    remove: "Remover",
    cancel: "Cancelar",
    deleteTitle: "Remover música",
    deleteConfirm: "Remover esta faixa da sua biblioteca? O arquivo salvo no dispositivo será apagado.",
    personalization: "Personalização",
    background: "Plano de fundo",
    color: "Cores",
    gradient: "Gradientes",
    image: "Imagens",
    customImage: "Enviar imagem própria",
    language: "Idioma",
    storage: "Armazenamento",
    used: "usado",
    of: "de",
    install: "Instalar na tela inicial",
    installHint: "Use o Z Music como um app, mesmo offline",
    installAction: "Instalar",
    installed: "App instalado ✓",
    installIosHint: "No iPhone: toque em Compartilhar e depois em \"Adicionar à Tela de Início\".",
    search: "Buscar na biblioteca",
    unknownArtist: "Artista desconhecido",
    unknownTitle: "Faixa sem título",
    offlineReady: "Offline",
    added: (n) => `${n} ${n === 1 ? "música adicionada" : "músicas adicionadas"}`,
    invalidFile: "Formato não suportado",
    removed: "Música removida",
    downloadStarted: "Download iniciado",
    clearImage: "Remover imagem",
    aboutStorage: "As músicas ficam salvas no seu dispositivo e funcionam offline.",
  },
  en: {
    appName: "Z Music",
    tagline: "Your sound, your way",
    library: "Library",
    settings: "Settings",
    home: "Home",
    upload: "Upload music",
    uploadHint: "Drag your files here or tap to choose",
    uploadFormats: "MP3 · WAV · M4A · FLAC",
    processing: "Processing",
    empty: "Your library is empty",
    emptyHint: "Upload your music to start listening",
    songsCount: (n) => `${n} ${n === 1 ? "song" : "songs"}`,
    nowPlaying: "Now playing",
    download: "Download",
    delete: "Delete",
    remove: "Remove",
    cancel: "Cancel",
    deleteTitle: "Remove song",
    deleteConfirm: "Remove this track from your library? The file stored on your device will be deleted.",
    personalization: "Personalization",
    background: "Background",
    color: "Colors",
    gradient: "Gradients",
    image: "Images",
    customImage: "Upload your own image",
    language: "Language",
    storage: "Storage",
    used: "used",
    of: "of",
    install: "Install to home screen",
    installHint: "Use Z Music like an app, even offline",
    installAction: "Install",
    installed: "App installed ✓",
    installIosHint: "On iPhone: tap Share, then \"Add to Home Screen\".",
    search: "Search your library",
    unknownArtist: "Unknown artist",
    unknownTitle: "Untitled track",
    offlineReady: "Offline",
    added: (n) => `${n} ${n === 1 ? "song added" : "songs added"}`,
    invalidFile: "Unsupported format",
    removed: "Song removed",
    downloadStarted: "Download started",
    clearImage: "Remove image",
    aboutStorage: "Your music is saved on your device and works offline.",
  },
};

export const PRESET_COLORS = ["#050505", "#0b1020", "#1a0b1e", "#0d1f1a", "#1e1408", "#160b0b", "#0a0f2c"];
export const PRESET_GRADIENTS = [
  "linear-gradient(160deg, #2b0b3a 0%, #050505 60%)",
  "linear-gradient(160deg, #0b2545 0%, #050505 60%)",
  "linear-gradient(160deg, #3a0b1e 0%, #050505 60%)",
  "linear-gradient(160deg, #0b3a2f 0%, #050505 60%)",
  "linear-gradient(160deg, #ff3366 0%, #a020f0 45%, #050505 100%)",
];
export const PRESET_IMAGES = [
  "https://images.unsplash.com/photo-1654198340681-a2e0fc449f1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxkYXJrJTIwYWJzdHJhY3QlMjBhZXN0aGV0aWMlMjB3YWxscGFwZXJ8ZW58MHx8fHwxNzg2Mzc4MTgwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1663970206579-c157cba7edda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYWJzdHJhY3QlMjBhZXN0aGV0aWMlMjB3YWxscGFwZXJ8ZW58MHx8fHwxNzg2Mzc4MTgwfDA&ixlib=rb-4.1.0&q=85",
];
